/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class QueryOperatorNaryForGraph extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("QueryOperatorNaryForGraph");
    }

    getFixupPrototypeFunction() { return QueryOperatorNaryForGraph.fixupPrototype; }

    static newInstance(model: Partial<QueryOperatorNaryForGraph>): QueryOperatorNaryForGraph {
        let obj = Object.assign(new QueryOperatorNaryForGraph(), model);
        QueryOperatorNaryForGraph.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<QueryOperatorNaryForGraph>): QueryOperatorNaryForGraph {
        if (!model) return null;
        return QueryOperatorNaryForGraph.newInstance(<QueryOperatorNaryForGraph> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: QueryOperatorNaryForGraph) {
        if (!obj) return;

        models.QueryOperatorNaryForGraph.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: QueryOperatorNaryForGraph): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, QueryOperatorNaryForGraph.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.terms) {
            for (let val of this.terms) {
                models.QueryOperator.fixupPrototype(val);
            }
        }
    }

    terms: Array<models.QueryOperator>;

}
